import React from 'react';
import PropTypes from 'prop-types';
import { useTheme } from 'react-jss';
import modalFooterUseStyles from './modalFooterUseStyles';

const ModalFooter = ({ align, children }) => {
  const theme = useTheme();
  const { wrenchModalActions, wrenchModalFooter } = modalFooterUseStyles({
    align,
    theme,
  });
  return (
    <footer className={wrenchModalFooter}>
      <div className={wrenchModalActions}>{children}</div>
    </footer>
  );
};

ModalFooter.propTypes = {
  /**
   * Align footer content
   */
  align: PropTypes.oneOf(['left', 'right']),
  /**
   * Modal footer contents
   */
  children: PropTypes.node.isRequired,
};

ModalFooter.defaultProps = {
  align: 'left',
};

export default ModalFooter;
